import { createSelector } from 'reselect';

import { content2VasSubscription } from '~/src/features/domru-tv/packages/helpers/contentSubscriptionFormatter';
import { TState } from '~/src/store';

export const selectFormattedSubscriptions = createSelector(
    (state: TState) => state.tvSubscriptions.items,
    subscriptions => content2VasSubscription(subscriptions),
);

export const selectSubscriptions = createSelector(
    [
        (state: TState) => state.auth.isAuth,
        (state: TState) => state.vas.subscriptions,
        selectFormattedSubscriptions,
    ],
    (isAuth, subscriptions, shopItems) => isAuth ? subscriptions : shopItems,
);
